import { useDataStore } from 'app/store/dataStore';
import { getUrlParams } from 'app/store/dataUtils';

export function resolveChatContext(args: ReturnType<typeof getUrlParams>) {
	let { chatId, driver, warehouse, shipment, language, sidebarEnabled } = args;

	if (sidebarEnabled) {
		const chatRoom = useDataStore.getState().currentChatRoom;
		if (chatRoom) {
			chatId = chatRoom._id;
			driver = chatRoom.driver;
			warehouse = chatRoom.warehouse;
			shipment = chatRoom.shipment;
		}
	}

	return {
		chatId,
		driver,
		shipment,
		language,
		warehouse,
		sidebarEnabled: sidebarEnabled === 'true'
	};
}
